import { useEffect, useRef } from 'react';

import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';

import config from '~config';

const UnloadEventInterceptor = (): null => {
    const dispatch = useAppDispatch();

    const isLoggingOut = useAppSelector(state => state.auth.loadings.logout);
    const authToken = useAppSelector(state => state.auth.userDetails.authToken);

    const isLoggingOutRef = useRef(isLoggingOut);
    const authTokenRef = useRef(authToken);

    useEffect(() => {
        isLoggingOutRef.current = isLoggingOut;
        authTokenRef.current = authToken;
    }, [isLoggingOut, authToken]);

    useEffect(() => {
        // Attach the event listener only when the user is authenticated
        if (authTokenRef.current) {
            window.addEventListener('beforeunload', (event) => {
                if (!isLoggingOutRef.current) {
                    event.preventDefault();
                    event.returnValue = true; // legacy browser support
                }
            });
        }

        window.addEventListener('pagehide', () => {
            // logout after refresh
            dispatch(combinedActions.authLogoutAttempt());

            // using keep alive fetch call to outlive the browser session (dispatching an action will not complete)
            fetch(`${config.baseUrl}/auth/logout`, {
                keepalive: true,
                method: 'POST',
                headers: {
                    'content-type': 'application/json',
                    'Authorization': `Bearer ${authTokenRef.current}`,
                },
            });
        });
    }, [authTokenRef.current]);

    return null;
};

export default UnloadEventInterceptor;
